<template>
  <va-modal
    :value="isOpen"
    id="callRatingDetailsModal"
    ref="callRatingDetailsModal"
    @cancel="onCancel"
    :hideDefaultActions="true"
  >
    <div slot="header" class="d-flex justify--space-between">
      <span
        class="modal-title">{{
          $t('clinical.canceled_call_requests.details_modal_title', { appointment_info: `${callRequestAppointment.person.name}` })
        }}</span>
    </div>
    <section class="evollu-form">
      <h5> {{ $t('clinical.appointment.title') }}</h5>
      <div class="form-row">
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('tables.columns.created_at') }}:</span>
          {{ callRequestAppointment.created_at | localTime('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.appointment_date') }}:</span>
          {{ callRequestAppointment.start | localTime('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.appointment_started_at') }}:</span>
          {{ callRequestAppointment.started_at | localTime('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.appointment_ended_at') }}:</span>
          {{ callRequestAppointment.ended_at | localTime('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 mb-3"><span
          class="is-bold ">{{ $t('clinical.canceled_call_requests.canceled_at') }}:</span>
          {{ callRequestAppointment.canceled_at | localTime('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.person.label') }}:</span> {{
            callRequestAppointment.person.name
          }}
        </div>
        <div class="col-12 col-md-6 mb-3"><span
          class="is-bold ">{{ $t('clinical.appointments.facility') }}:</span> {{ callRequestAppointment.facility.name }}
        </div>
      </div>
      <h5>{{ $t('clinical.canceled_call_requests.details') }}</h5>
      <div class="row mb-1">
        <label class="is-bold">{{ $t('clinical.canceled_call_requests.cancel_reason') }}:</label>&nbsp;
        <span>
          {{
            callRequestAppointment.cancel_reason_id ? $t(`evocall.requests.cancelation_reasons.${callRequestAppointment.cancel_reason_id}`) : 'N/A'
          }}
        </span>
      </div>

      <div>
        <label class="is-bold ">{{ $t('clinical.canceled_call_requests.cancel_reason_observations') }} </label>
        <va-input
          :value="callRequestAppointment.cancel_reason_observations || $t('clinical.call_ratings.no_comment')"
          type="textarea"
          :min-rows="3"
          :readonly="true"
          :disabled="true"
        />
      </div>
    </section>
  </va-modal>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    callRequestAppointment: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  computed: {
    dispenserName: function () {
      const dispenser = _.get(this.callRequestAppointment, 'parent.user', null)
      return dispenser ? dispenser.nickname || dispenser.name : null
    },
    audiologistName: function () {
      const audiologist = _.get(this.callRequestAppointment, 'user', null)
      return audiologist ? audiologist.nickname || audiologist.name : null
    },
  },
  methods: {
    onCancel: function () {
      this.$emit('modalClosed')
      setTimeout(() => {
        this.isOpen = false
      }, 500)
    }
  }
}
</script>
